const state = () => ({
  isValid: false,
  phoneNumber: '',
  phoneCountry: { code: 'CZ', prefix: '+420', example: '123 456 789' }
});

const getters = {
  isValid(state) {
    return state.isValid;
  },
  phone(state) {
    if (!state.phoneNumber?.length) {
      return null;
    }

    return {
      prefix: state.phoneCountry.prefix,
      number: state.phoneNumber
    };
  },
  phoneNumber(state) {
    return state.phoneNumber;
  },
  phoneCountry(state) {
    return state.phoneCountry;
  }
};

const mutations = {
  setIsValid(state, payload) {
    state.isValid = payload;
  },
  updatePhoneNumber(state, payload) {
    state.phoneNumber = payload;
  },
  updatePhoneCountry(state, payload) {
    state.phoneCountry = payload;
  },
  resetStore(storeState) {
    Object.assign(storeState, state());
  }
};

const actions = {
  updatePhoneNumber({ commit }, payload) {
    commit('updatePhoneNumber', payload);
  },
  updatePhoneCountry({ commit }, payload) {
    commit('updatePhoneCountry', payload);
  },
  resetPhone({ commit }) {
    commit('updatePhoneNumber', '');
    commit('updatePhoneCountry', { code: 'CZ', prefix: '+420', example: '123 456 789' });
  }
};

export const phone = {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
};
